import Page from "@/Pages/Page";
import React from "react";
import ContactForm from "@/Organisms/ContactForm";

export default function Contact() {

  return <Page title={'Contact'} harvestId={10883}>

    <section className={'py-10'}>
      <div className="max-w-3xl mx-auto text-center">
        <h1 className=" my-5">Contact opnemen</h1>
        <p>Heb je vragen over een product of wil je adverteren op Mensenlinq.nl? Neem contact met ons op. We helpen je graag!</p>
      </div>

      <div className="max-w-3xl mx-auto grid grid-cols-1  md:grid-cols-2 gap-6 ">
        <div className="bg-white shadow-md rounded-md my-5 p-5 text-center">

          <div className="icon-circle bg-beige"><i className="fa-regular fa-paper-plane"></i></div>


          <h3>Mail ons</h3>
          <p>Onze medewerkers staan voor je klaar om jouw vragen te beantwoorden.</p>
          <a href="mailto:info@mensenlinq.nl" className="btn btn-primary my-5 ">Mail naar info@mensenlinq.nl</a>
        </div>

        <div className="bg-white shadow-md rounded-md my-5 p-5 text-center">
          <div className="icon-circle bg-beige"><i className="fa-brands fa-linkedin"></i></div>
          <h3>LinkedIn</h3>
          <p>Volg ons op LinkedIn en blijf op de hoogte van alle ontwikkelingen in de uitvaartbranche.</p>
          <a href="https://nl.linkedin.com/company/mensenlinq" className="btn btn-primary my-5">Volg ons op LinkedIn</a>
        </div>

      </div>
    </section>


    <section className="bg-beige py-10">
      <ContactForm />
    </section>
  </Page>
}
